import { render, staticRenderFns } from "./ArticleDetail.vue?vue&type=template&id=2bf76a77&scoped=true&"
import script from "./ArticleDetail.vue?vue&type=script&lang=js&"
export * from "./ArticleDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDetail.vue?vue&type=style&index=0&id=2bf76a77&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./ArticleDetail.vue?vue&type=style&index=1&id=2bf76a77&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf76a77",
  null
  
)

export default component.exports